import breakpoints from './style.module.scss';

export enum BreakPoint {
  MOBILE,
  TABLET = parseInt(breakpoints.tablet),
  TABLET_LANDSCAPE = parseInt(breakpoints.tabletLandscape),
  DESKTOP = parseInt(breakpoints.desktop),
  DESKTOP_BIG = parseInt(breakpoints.desktopBig)
}

export function findBreakPoint(sidebarWidth: number = 0): BreakPoint {
  let previousBreakpoint = BreakPoint.MOBILE;

  for (const key in BreakPoint) {
    const breakpoint = BreakPoint[key as keyof typeof BreakPoint];

    // iterating through an enum will essentially loop through the enum
    // twice, producing both the key of the enum as well as the value of the
    // enum always as a string, so here we have to check if the current
    // breakpoint is the key or the value.
    if (!isNaN(breakpoint)) {
      if (window.innerWidth - sidebarWidth < breakpoint) {

        return previousBreakpoint;
      } else {
        previousBreakpoint = breakpoint;
      }
    }
  }

  return BreakPoint.DESKTOP_BIG; // default case
}
